import React, { useCallback, useEffect, useState } from 'react'
import SetupCard from '../setupWiz/SetupCard';
import {getSetupCardItemsPath, OrderedSteps, pathToSteps, StepId} from '../../../hooks/useSelector';
import { useConfigStepsContext } from '../../../providers/ConfigStepsContextProvider';
import { useFolderListenerContext } from '../../../providers/FolderListenerContextProvider';
import { isRootOrAbove, useConfigPathContext } from '../../../providers/ConfigPathContextProvider';
import { isRoot } from '../../../hooks/useConfigsNavigator';
import { LoadCycle, useConfigsDataContext } from '../../../providers/ConfigsDataContextProvider';
import './Selector.css'

const Selector = () => {
  // TODO: No need for configSteps! we can generate this from the configPath. it contains the Wizards Steps in it.  
  const {configSteps, setConfigSteps}   = useConfigStepsContext();
  const {configPath}                    = useConfigPathContext();
  const [displayCards, setDisplayCards] = useState();
  const [reloadFlag, setReloadFlag]     = useState(false);
  const {folderChanged}                 = useFolderListenerContext();
  const {getNode, loadCycle}            = useConfigsDataContext();
  const [firstAppName, setFirstAppName] = useState(null);
  
  const refreshMe = useCallback(() => setReloadFlag(prev => !prev), []);

  useEffect(()=>{
    // console.log('[Selector] folderChanged');
    refreshMe();
  }, [folderChanged, refreshMe]);

  useEffect(()=>{
    if (!isRootOrAbove(configPath) || isRoot(configPath)) {
      setConfigSteps(pathToSteps(configPath));
    }
  }, [configPath, setConfigSteps]);

  useEffect(()=>{
    if (configSteps) {
      // Build the wizard cards from configSteps + next one if has empty slot...
      const cards = OrderedSteps.reduce( (acc, step) => {
        if (step in configSteps) {
          acc.cards.push(step);
        }
        else {
          if (acc.hasEmptySlot) {
            acc.cards.push(step);
            acc.hasEmptySlot = false;
          }
        }
        
        return acc;
      }, { cards: [], hasEmptySlot: true }).cards;
    
      // console.log('[Setup Selector] Cards:', JSON.stringify(cards, null, 2));
      setDisplayCards(cards);
    }

  }, [configSteps, reloadFlag]);

  useEffect(()=>{
    // console.log('[Selector] loadCycle:', loadCycle);
    if (loadCycle === LoadCycle.Fetched) {

      // Get the first app name under the apps array using the getAppsPath as the path to the apps.
      const appsPath = getSetupCardItemsPath(null, StepId.APPS);
      // console.log('[Selector] appsPath:', appsPath);

      const appsNode = getNode(appsPath);
      // console.log('[Selector] appsNode:', JSON.stringify(appsNode, null, 2));
  
  
      // Get the first item under appsNode that is not named "kiponosInfo".
      const appName = Object.keys(appsNode || {}).find(name => name !== 'kiponosInfo');
      // console.log('[Selector] appName:', appName);
      setFirstAppName(appName);
    }
  }, [loadCycle, getNode]);

  // ------  Render  ------
  const cardsComp = displayCards?.map(stepName => <SetupCard stepName={stepName} key={stepName} pathChanged={folderChanged}/>);

  const defaultBaseNoneSelected = Object.keys(configSteps).length === 0;
  const defaultBaseShowingReleases = Object.keys(configSteps).length === 1;
  const defaultBaseShowingEnvs = Object.keys(configSteps).length === 2; 
  const defaultBaseShowingCfgs = Object.keys(configSteps).length === 3;

  return (
    <div className='selector'>
      <div className='selectorCards'>
        {cardsComp}
      </div>
      <div>
        {defaultBaseNoneSelected && (
          <div className='emptyState'>

            <div className="welcome-panel">
              <h1>✨ Welcome to Kiponos.io ✨</h1>
              <h2>The Real-Time Revolution in Config Management starts here</h2>

              <p>Want to <span className="highlight">see the magic</span> in action?</p>
              <p>Follow these quick steps and watch your changes sync instantly:</p>

              <ol>
                <li>
                  Duplicate this page to another browser window and log in with your credentials.<br />
                  <em>&nbsp;&nbsp;(your initial password was sent to your email)</em>.
                </li>
                <li>
                  In the <span className="highlight">Applications</span> box above, click the ➕ button to create a new application.
                </li>
                <li>
                  Look at your other window — did you see it appear right away? 🚀
                  That's the power your entire team gets, out of the box.
                </li>
              </ol>

              <p>
                No redeploys. No restarts. No waiting.<br />
                Every config update here instantly reaches your Spring Boot servers or Java apps.
              </p>

              <p>
                ✅ True real-time syncing<br />
                ✅ Instant observability across environments<br />
                ✅ Seamless team collaboration
              </p>


              <h3>Let's do more!</h3>
              <h3>Above, click <strong>'{firstAppName}'</strong> to bring the "Releases" box</h3>


              <div className="footer">
                <p>Kiponos makes configs <span className="highlight">come alive</span>. 🔮</p>
              </div>
            </div>
          </div>
        )}

        {defaultBaseShowingReleases && (
          <div className='emptyState'>
            <h1>Next ➡️ Select the Release</h1>
            <h2>Click the default: v1.0.0</h2>
            <h3>It will show the Environment Step</h3>
          </div>
        )}

        {defaultBaseShowingEnvs && (
          <div className='emptyState'>
            <h1>Next ➡️ Select the Environment</h1>
            <h2>Click the default "dev" to show the last step</h2>
          </div>
        )}

        {defaultBaseShowingCfgs && (
          <div className='emptyState'>
            <h1>Great! Next ➡️ Select the "base" config profile</h1>
            <h2>It will show the Config View where you can define config items</h2>
          </div>
        )}

      </div>
    </div>
  )
}


//export default React.memo(Selector);
export default Selector;